import { Component, ContentChild, ElementRef, Input, OnChanges, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControlOptions, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'fin-form-array',
  templateUrl: 'form-array.component.html',
  styleUrls: ['form-array.component.scss'],
})
export class FormArrayComponent implements OnInit, OnChanges {
  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  controlName: string;

  @Input()
  translationPrefix: string;

  @Input()
  formGroupConfig: { [key: string]: any };

  @Input()
  formGroupOptions: AbstractControlOptions = {};

  @Input()
  minGroups = 0;

  @Input()
  maxGroups = 100;

  @Input()
  hideGroups = false;

  @Input()
  displayLabels = false;

  @Input()
  isNestedArray = false;

  @Input()
  displayContainerStyles = true;

  @Input()
  compressedList = false;

  @Input()
  disabled = false;

  @ContentChild(TemplateRef, { static: true }) formGroup: TemplateRef<any>;

  @ViewChild('addGroupButtonElement', { static: false })
  addGroupButtonElement: ElementRef;

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    for (let i = this.formArray.length; i < this.minGroups; i++) {
      this.formArray.push(this.fb.group(this.formGroupConfig, this.formGroupOptions));
    }
  }

  ngOnChanges(): void {
    while (this.maxGroups < this.formArray.length) {
      this.formArray.removeAt(this.formArray.length - 1);
    }
  }

  addFormGroup(): void {
    if (this.formArray.length < this.maxGroups) {
      this.formArray.push(this.fb.group(this.formGroupConfig, this.formGroupOptions));
      this.parentForm.markAsDirty();
    }
  }

  removeFormGroup(index: number): void {
    this.addGroupButtonElement.nativeElement.focus();
    this.formArray.removeAt(index);
    this.parentForm.markAsDirty();
  }

  setFocus(): void {
    this.addGroupButtonElement.nativeElement.focus();
  }

  get formArray(): UntypedFormArray {
    return this.parentForm.get(this.controlName) as UntypedFormArray;
  }
}
